// ─────────────────────────────────────────────────────────────────────────────
// Stockage de la session (token + utilisateur) — seul module qui connaît les
// clés localStorage. Les clés sont conservées pour ne pas déconnecter les
// sessions existantes.
// ─────────────────────────────────────────────────────────────────────────────

const TOKEN_KEY = "bi_token";
const USER_KEY = "bi_user";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export const session = {
  getToken(): string | null {
    return read(TOKEN_KEY);
  },

  getUser<T = Record<string, unknown>>(): T | null {
    const raw = read(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },

  save(token: string, user?: unknown): void {
    localStorage.setItem(TOKEN_KEY, token);
    if (user !== undefined) localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  setUser(user: unknown): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  clear(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};
